import React from "react"
import Header, {Footer} from './header'
import './styles.css'

var homepage = {__html:
   `
<div class="container">

</div>
<script>
 $(document).ready(function() {
    $('.carousel').carousel({
       interval: 8000
    })
 });
</script>

<!--
This template is provided as a custom template for the homepage, for
when it is configured as an editable page in the navigation tree. Feel
free to modify it.
-->


<section class="no-margin" id="main-slider">
        <div class="carousel slide wet-asphalt">
            <div class="carousel-inner">
               
               
               
                    
                <div style="background-image: url(https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/slider/.thumbnails/circles.jpeg/circles-1920x690.jpeg)" class="item active">
                    
               
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="carousel-content centered" style="margin-top: 265px;">
                                   <h2 class="animation animated-item-1">Datum </h2>
                                   <h4 class="animation animated-item-2">Going Beyond the Data, Achieving Actionable Insights</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!--/.item-->
                
                                               
            </div>
        </div>
        
</section>



    
        
         <section class="home_section" 
                  style="background-color: #f6f6ff; padding-top: 40px; padding-bottom: 40px;" 
                  id="about">
            
        <!-- fontawecome <i> tags have to go here -->
        <div class="container"></div>
         
            
               <!-- section content class="home_section"-->
<div class="container">
<h2 align="center">About us</h2>
<div style="width: 50%; margin-left: 25%;">
<div style="margin: 10px;">
<p align="center"><span style="color: #777777;"><em>We are a diverse group of Data Scientists with a broad array of domain knowledge and experience in building end-to-end machine learning applications. </em></span></p>
<p align="center"><span style="color: #777777;"><em><br /> Whether you have a specific application in mind, or you simply want to explore your data, Datum &amp; Co. can help you enrich your business. Datum &amp; Co. will guide you from pre-planning and roadmapping, all the way to product deployment and maintenance. <br /></em></span></p>
</div>
<div class="col-sm-12 outerbox" style="text-align: center;"><strong><a class="my_button" href="/team/">Meet our team</a></strong></div>
</div>
</div> 
            
         </section>
         
    
        
         <section class="home_section" 
                  style="background-color: #e6e6e6; padding-top: 40px; padding-bottom: 40px;" 
                  id="services">
            <div class="container">
<h2 align="center">Services</h2>
<div style="width:50%; margin-left:25%;">
<div style="margin: 10px">
  <p align="center"><font color="#777"><em>We offer a wide array of services that can help any company looking to integrate data into their workflow, product, or long-term planning.  While each individual engagement with Datum & Co. will be tailored to your specific needs, here are some basic frameworks to get you started with planning your company's needs.</em></font></p>
  </div>
</div>
<div class="row">
<div class="col-sm-4 outbox">
</div>
<div class="col-sm-4 outbox">
</div>
<div class="col-sm-4 outbox">
</div>
</div>
<div class="row">
<div class="col-sm-4 outbox">
<div class="whitebox">
<p style="text-align: center;"><i class="fa fa-database fa-3x"></i></p>
</div>
</div>
<div class="col-sm-4 outbox">
<div class="whitebox">
<p style="text-align: center;"><i class="fa fa-line-chart fa-3x"></i></p>
</div>
</div>
<div class="col-sm-4 outbox">
<div class="whitebox">
<p style="text-align: center;"><i class="fa fa-cubes fa-3x"></i></p>
</div>
</div>
</div>
</div> 
            
               <!-- section content class="home_section"-->
<div class="container">
<div class="row">
<div class="col-sm-4 outerbox">
<div class="whitebox">
<p style="text-align: center;"><strong>Data Pipelining &amp;&nbsp;Warehousing </strong></p>
<p style="text-align: center;">Setting up your data pipeline is an essential first step towards becoming a data-centric company, we can help you automate the collection and integration of your data. <em>This service is best suited for businesses without an integrated way to utilize their data and discover insights.</em></p>
</div>
</div>
<div class="col-sm-4 outerbox">
<div class="whitebox">
<p style="text-align: center;"><strong>Data Mining &amp; Predictive Analytics</strong></p>
<p style="text-align: center;">Similar to traditional data analysis for Business Intelligence, we provide quantitatively validated insights via our expertise in machine learning. <em>This service is best suited for businesses looking to expand, restructure, or improve the efficiency of their company. </em></p>
</div>
</div>
<div class="col-sm-4 outerbox">
<div class="whitebox">
<p style="text-align: center;"><strong>End-to-end Data Applications</strong></p>
<p style="text-align: center;">We can improve your software with machine learning features, or alleviate labor-intensive tasks. <em>This service is best suited for companies that wish to add machine learning features to their existing application.</em></p>
</div>
</div>
</div>
<div class="row">
<div class="col-sm-4 outerbox" style="text-align: center;"><strong><a class="my_button" style="margin: auto;" href="/services#anchor_1"> Learn more</a></strong></div>
<div class="col-sm-4 outerbox" style="text-align: center;"><strong><a class="my_button" href="/services#anchor_2">Learn more</a></strong></div>
<div class="col-sm-4 outerbox" style="text-align: center;"><strong><a class="my_button" href="/services#anchor_3">Learn more</a></strong></div>
</div>
</div> 
            
         </section>
         
    
        
         <section class="home_section" 
                  style="background-color: #cecece; padding-top: 40px; padding-bottom: 40px;" 
                  id="products">
            <div class="container">
<h2 align="center">Products</h2>
<div style="width:50%; margin-left:25%;">
<div style="margin: 10px">
  <p align="center"><font color="#777"><em>In addition to data science consulting services we also offer data products both for businesses as well as consumers.</em></font></p>
  </div>
</div>
<div class="row">
<div class="col-sm-6 outbox">
</div>
<div class="col-sm-6 outbox">
</div>
</div>
<div class="row">
<div class="col-sm-6 outbox">
<div class="whitebox">
<p style="text-align: center;"><i class="fa fa-bar-chart fa-3x"></i></p>
</div>
</div>
<div class="col-sm-6 outbox">
<div class="whitebox">
<p style="text-align: center;"><i class="fa fa-mobile fa-3x"></i></p>
</div>
</div>
</div>
</div>         
            
               <!-- section content class="home_section"-->
<div class="container">
<div class="row">
<div class="col-sm-6 outerbox">
<div class="whitebox">
<p style="text-align: center;"><strong>Analytics Dashboard</strong></p>
<p style="text-align: center;">We have developed a series of dashboard products that can be customized for your data. &nbsp;Use&nbsp;our contact page to get started on a custom dashboard for your data.</p>
<p style="text-align: center;"><img style="width: 90%;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/dashboard.png" alt="Robista" /></p>
</div>
</div>
<div class="col-sm-6 outerbox">
<div class="whitebox">
<p style="text-align: center;"><strong>Robista Productivity Apps</strong></p>
<p style="text-align: center;">We are continuing to develop a line of data-driven personal productivity applications, ranging from smart email tagging, to collaboration and search tools for slack, to machine learning driven writing tools. &nbsp;Contact us to learn more about these products.</p>
<p style="text-align: center;"><img style="width: 90%;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/customapp.png" alt="Robista" /></p>
</div>
</div>
</div>
<div class="row">
<div class="col-sm-6 outerbox" style="text-align: center;"><strong><a class="my_button" style="margin: auto;" href="mailto:info@datumco.io"> Contact us for a demo</a></strong></div>
<div class="col-sm-6 outerbox" style="text-align: center;"><strong><a class="my_button" href="https://robista.io/">Learn more</a></strong></div>
</div>
</div> 
            
         </section>
         
    


 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/jquery.prettyPhoto.js"></script>
 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/jquery.isotope.min.js"></script>
 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/main.js"></script>



      `}

const Home = () => (
   <div>
      <Header />
   <div dangerouslySetInnerHTML={homepage} />
      <Footer />
      </div>
)
export default Home



/** WEBPACK FOOTER **
 ** ./src/pages/home.js
 **/